import { routes } from "./constants/routes";
import { AppIconType } from "../components/Core/AppIcon/AppIcon";

export interface SubMenuItem {
	title: string;
	route: string;
	scope?: string[];
	/** Only shown when the AI assistant is available to the user (org flag + chat scope). */
	aiOnly?: boolean;
	/** Translation key of a heading rendered above the first visible item of each section. */
	section?: string;
	/**
	 * Renders the user's saved dashboards as the rows of this item (with a
	 * "new dashboard" button in the section heading) instead of a link.
	 */
	listsDashboards?: boolean;
}

export interface MenuItem {
	icon: AppIconType;
	title: string;
	route?: string;
	items?: SubMenuItem[];
	/**
	 * If the user has any of these scopes, the menu item will be visible.
	 */
	scope?: string[];
}

export const MENU_ITEMS: MenuItem[] = [
	{
		icon: "calendar",
		title: "SCHEDULE",
		route: routes.SCHEDULE,
	},
	{
		icon: "job",
		title: "JOBS",
		route: routes.JOBS,
	},
	{
		icon: "consultant",
		title: "CONSULTANTS",
		route: routes.CONSULTANTS,
	},
	{
		icon: "time",
		title: "TIME_REPORTS",
		route: routes.TIME_REPORTS_THIS_MONTH,
	},
	{
		icon: "customer",
		title: "CUSTOMERS",
		route: routes.CUSTOMERS,
	},
	{
		icon: "recruitment",
		title: "RECRUITMENT",
		route: routes.RECRUITMENT,
	},
	{
		icon: "economy",
		title: "ECONOMY",
		scope: ["invoice-batch.*", "salary-batch.*", "contract.*", "invoice.*"],
		items: [
			{
				title: "CONTRACTS",
				route: routes.CONTRACTS,
				scope: ["contract.*"],
			},
			{
				title: "INVOICES",
				route: routes.INVOICES,
				scope: ["invoice.*"],
			},
			{
				title: "invoice.invoiceBatches",
				route: routes.INVOICE_BATCHES,
				scope: ["invoice-batch.*"],
			},
			{
				title: "SALARY_SECTION",
				route: routes.SALARY,
				scope: ["salary-batch.*"],
			},
			{
				title: "AGREEMENT",
				route: routes.AGREEMENT,
				scope: ["collective-agreement.create"],
			},
		],
	},
	{
		icon: "report",
		title: "REPORTS",
		scope: ["report.*"],
		items: [
			{
				title: "reports.customerReport",
				route: routes.CUSTOMERS_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.customerContactReport",
				route: routes.CUSTOMER_CONTACTS_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.consultantReport",
				route: routes.CONSULTANTS_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.candidateReport",
				route: routes.CANDIDATES_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.consultantWorkedHoursReport",
				route: routes.CONSULTANTS_WORKED_HOURS_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.soldHoursAndRevenueReport",
				route: routes.SOLD_HOURS_AND_REVENUE_REPORT,
				section: "reports.excelExports",
			},
			{
				title: "reports.dashboards",
				route: routes.REPORT_BUILDER,
				aiOnly: true,
				section: "reports.dashboards",
				listsDashboards: true,
			},
		],
	},
	// The legacy KPI dashboard (routes.KPI_DASHBOARD) stays reachable by URL for
	// benchmarking against the report builder, but is no longer in the menu.
	{
		icon: "more",
		title: "MORE",
		items: [
			{
				title: "DOCUMENTS_TITLE",
				route: routes.DOCUMENTS,
				scope: ["job_report.*"],
			},
			{
				title: "JOB_REPORTS",
				route: routes.JOB_REPORTS,
				scope: ["job_report.*"],
			},
			{
				title: "FEEDBACK_REPORT",
				route: routes.FEEDBACK_REPORT,
				scope: ["log.read"],
			},
			{
				title: "SETTINGS",
				route: routes.SETTINGS,
				scope: ["organisation.update"],
			},
			{
				title: "USERS",
				route: routes.INTERNAL_USERS,
				scope: ["account.organisation.*"],
			},
			{
				title: "API_LOGS",
				route: routes.API_LOGS,
				scope: ["log.read"],
			},
			{
				title: "RESPONSE_TIME_STATS",
				route: routes.REPSONSE_TIME_STATS,
				scope: ["log.read"],
			},
			{
				title: "LOGOUT",
				route: routes.LOGOUT,
			},
		],
	},
];
